//
// Menu store
//

import { CODE_VALID } from './input';

// ------------------------------------
// Action definitions
// ------------------------------------

export const SHOW_MENU = 'MENU/SHOW';
export const HIDE_MENU = 'MENU/HIDE';
export const OPEN_SECTION = 'MENU/OPEN_SECTION';
export const CLOSE_SECTION = 'MENU/CLOSE_SECTION';

// ------------------------------------
// Action creators
// ------------------------------------

export const showMenu = () => ({
  type: SHOW_MENU
});

export const hideMenu = () => ({
  type: HIDE_MENU
});

export const openSection = id => ({
  type: OPEN_SECTION,
  id
});

export const closeSection = () => ({
  type: CLOSE_SECTION
});

export const toggleMenu = () => (dispatch, getState) => {
  const { menu } = getState();

  menu.visible
    ? dispatch(hideMenu())
    : dispatch(showMenu());
};

export const toggleSection = id => (dispatch, getState) => {
  const { menu } = getState();

  menu.section === id
    ? dispatch(closeSection())
    : dispatch(openSection(id));
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  visible: true,
  section: null
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MENU:
    case CODE_VALID:
      return {
        ...state,
        visible: true
      };

    case HIDE_MENU:
      return {
        ...state,
        visible: false
      };

    case OPEN_SECTION:
      return {
        ...state,
        section: action.id
      };

    case CLOSE_SECTION:
      return {
        ...state,
        section: null
      };

    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js